export enum OperatingSystem {
    macOS = "macOS",
    Windows = "Windows",
}

export const getOperatingSystem = (): OperatingSystem => {
    if (navigator.userAgent.includes("Mac")) {
        return OperatingSystem.macOS;
    }
    return OperatingSystem.Windows;
};
